import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-250" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-251" data-mp="3ssemmyy53ipw">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-252" data-mp="3nzbnmbalfh2b">
          {shortTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-black border border-gold/20 p-6 rounded-2xl" data-id="element-253" data-mp="5kawvi4tqr2d" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 étoiles sur 5" data-id="element-254" data-mp="aiujlkr8s6vs">
                {[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" data-id="element-255" data-mp="2cctuw64d6o8h" data-mpi={star} />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-256" data-mp="cdihg7lnqole">&laquo;&nbsp;{testimonial.text}&nbsp;&raquo;</p>
              <div className="flex items-center gap-3" data-id="element-257" data-mp="geu6oc0md7t2">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-258" data-mp="lcvs33lipj7p">
                  {testimonial.initials}
                </div>
                <div data-id="element-259" data-mp="v3qf4a6l8mu7">
                  <div className="font-bold text-white text-sm" data-id="element-260" data-mp="v2fa671ep91i">{testimonial.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-261" data-mp="1018pm5097a4b">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}